<script>
import { event } from "vue-analytics";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("menu", ["active", "route"])
  },

  methods: {
    verifyMenu(arr) {
      return (arr.includes(this.route) && !this.active) ||
        arr.includes(this.active)
        ? true
        : false;
    },

    sendEvents(name) {
      event("cliente", "click", `SubMenu:${name}`);
    }
  }
};
</script>

<template>
  <div class="sub-menu">
    <div class="container">
      <ul
        id="orders"
        class="list"
        :class="{'active': verifyMenu(['orders', 'order', 'order-history', 'invoices', 'coupons', 'subscriptions', 'cycle'])}"
      >
        <router-link
          @click.native="sendEvents('order-history')"
          :to="{name: 'order-history'}"
          :class="{'active': route === 'order-history' || route === 'order'}"
        >
          <li id="order-history">
            <img src="../../../static/submenu-order-history.svg" />Histórico de Limpezas
          </li>
        </router-link>

        <router-link
          @click.native="sendEvents('subscriptions')"
          :to="{name: 'subscriptions'}"
          :class="{'active': route === 'subscriptions' || route === 'cycle'}"
        >
          <li id="subscriptions">
            <img src="../../../static/submenu-signature.svg" />Assinaturas
          </li>
        </router-link>

        <!-- <router-link  :to="{name: 'invoices'}" :class="{'active': route === 'invoices'}">
                <li id="invoices"><img src="../../../static/submenu-invoices.svg">Notas Fiscais </li>
        </router-link>-->

        <!-- <router-link  :to="{name: 'coupons'}" :class="{'active': route === 'coupons'}">
                <li id="coupons"><img src="../../../static/submenu-coupons.svg">Cupons </li>
        </router-link>-->
      </ul>

      <ul
        id="user"
        class="list"
        :class="{'active': verifyMenu(['user', 'personal-data', 'credit-cards', 'wallet'])}"
      >
        <!-- <router-link  :to="{name: 'credit-cards'}" :class="{'active': route === 'credit-cards'}">
                <li id="credit-cards"><img src="../../../static/submenu-credit-cards.svg">Cartões de Crédito </li>
        </router-link>-->

        <!-- <router-link  :to="{name: 'wallet'}" :class="{'active': route === 'wallet'}">
                <li id="wallet"><img src="../../../static/submenu-wallet.svg">Carteira </li>
        </router-link>-->
      </ul>

      <ul
        id="preferences"
        class="list"
        :class="{'active': verifyMenu(['preferences', 'favorites', 'blocked'])}"
      >
        <!-- <router-link  :to="{name: 'favourites-professionals'}" :class="{'active': route === 'favorites'}">
          <li id="favorites">
            <img src="../../../static/submenu-favorites.svg">Favoritos
          </li>
        </router-link>-->

        <!-- <router-link  :to="{name: 'blocked-professionals'}" :class="{'active': route === 'blocked'}">
                <li id="blocked"><img src="../../../static/submenu-blocked.svg">Bloqueados </li>
        </router-link>-->
      </ul>
    </div>
  </div>
</template>

<style scoped>
.sub-menu {
  position: relative;
  width: 100%;
  height: 50px;
  left: 0;
  top: 0;
  color: #fff;
  background: #fff;
  box-shadow: 0px 8px 10px -11px rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.sub-menu ul.list {
  position: absolute;
  color: #000;
  margin: 0 0 0 230px;
  padding: 0;
  top: -50px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  list-style-type: none;
  transition: all 0.25s ease;
}

.sub-menu ul.list.active {
  top: 0;
}

.sub-menu ul.list a {
  font-weight: 400;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  margin-right: 20px;
  padding: 0 15px;
  cursor: pointer;
  transition: all 0.25s ease;
  border-bottom: 4px solid #fff;
  height: calc(100% - 4px);
}

.sub-menu ul.list a li {
  display: flex;
  align-items: center;
}

.sub-menu ul.list a img {
  height: 18px;
  padding-right: 10px;
}

.sub-menu ul.list a:hover,
.sub-menu ul.list a.active {
  border-bottom: 4px solid var(--purple);
}

@media (max-width: 992px) {
  .sub-menu {
    display: none !important;
  }
}

@media (max-width: 1200px) {
  .sub-menu ul.list {
    margin: 0 0 0 200px !important;
  }
  .menu ul.list li {
    font-size: 16px;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/SubMenu.vue